export default __webpack_public_path__ + "static/media/nykaa.fa84a520.png";